import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import UpdateIcon from "@material-ui/icons/Update";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
  PROFICIENCY_LEVELS,
  getProficiencyLabel,
} from "../genericFunctions/languageProficiencies";

const LanguageItem = (props) => {
  const updateLanguage = props.updateLanguage;
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [language, setLanguage] = useState({
    _id: null,
    name: "",
    proficiency: "",
  });

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setLanguage({
      _id: props.language._id,
      name: props.language.name,
      proficiency: props.language.proficiency,
    });
  }, [props.editing]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #e1e1e1",
        padding: "5px 5px 5px 0px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <p
          style={{
            margin: "0",
            marginRight: "10px",
            padding: "15px 0%",
          }}
        >
          {language.name}
        </p>
        {!props.editing && (
          <p
            style={{
              margin: "0",
              marginRight: "10px",
              padding: "15px 0%",
            }}
          >
            {getProficiencyLabel(language.proficiency, props.profileLanguage)}
          </p>
        )}
      </div>
      {props.editing && (
        <>
          <Select
            name="proficiency"
            value={language.proficiency === undefined ? "" : language.proficiency}
            onChange={(e) => {
              setLanguage({ ...language, proficiency: e.target.value });
            }}
            style={{ marginTop: "5px", width: "230px" }}
          >
            {PROFICIENCY_LEVELS.map((proficiency) => (
              <MenuItem key={proficiency} value={proficiency}>
                {getProficiencyLabel(proficiency, props.profileLanguage)}
              </MenuItem>
            ))}
            <MenuItem value=""></MenuItem>
          </Select>

          <IconButton
            variant="outlined"
            color="primary"
            style={{ justifySelf: "flex-end" }}
            onClick={(e) => updateLanguage(e, language)}
          >
            <UpdateIcon />
          </IconButton>
          <IconButton
            variant="outlined"
            color="secondary"
            style={{ justifySelf: "flex-end" }}
            onClick={() => props.removeLanguage(props.language)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      )}
    </div>
  );
};

export default LanguageItem;
